import {
    ComponentStoreV2Factory,
} from '../../../../../../../../../packages/client/src/app/modules/shared/store/common/component-store-v2.factory';
import { Injectable } from '@angular/core';

@Injectable()
export class SocialServiceOfferNoteDialogStore extends ComponentStoreV2Factory {

}
